import { HttpClientService } from './common/http-client.service';

export class BackendBaseService {
  url: string;

  constructor(public httpClient: HttpClientService) {}

  create(params: any): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, params);
  }

  delete(id: number): Promise<any> {
    return this.httpClient.delete(`${this.url}/${id}.json`);
  }

  edit(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}/edit.json`);
  }

  formOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { form_options: true });
  }

  get(id: number, params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`, params);
  }

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  save(params: any): Promise<any> {
    if(params.id)
      return this.httpClient.put(`${this.url}/${params.id}.json`, params);
    else
      return this.httpClient.post(`${this.url}.json`, params);
  }

  searchOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { search_options: true });
  }

  show(id: number): Promise<any> {
    return this.get(id);
  }

  update(params: any) {
    return this.httpClient.put(`${this.url}/${params.id}.json`, params);
  }
}